/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_Reference_Time_LabelInputs */



/**
* | output |
* | --- |
* | "Reference Time" |
*
* @param {Audio_Description_Export_Bwf_Reference_Time_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_reference_time_label = /** @type {((inputs?: Audio_Description_Export_Bwf_Reference_Time_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_Reference_Time_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temps de référence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Referenzzeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempo di riferimento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Референтное время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tiempo de referencia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("参考时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("基準時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संदर्भ समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo de referência")
	return /** @type {LocalizedString} */ ("Reference Time")
});